import { apiSlice } from '../../apiSlice';

export const classCalendarAPI = apiSlice
  .enhanceEndpoints({
    addTagTypes: ['teachers'],
  }).injectEndpoints({
    endpoints: (build) => ({
      getClassTeachers: build.query({
        query: (classCodes: string[]) => ({
          url: `/mgmt/campus-classes/class-calendar/teachers`,
          method: 'POST',
          data: classCodes,
        }),
        providesTags: ['teachers'],
      }),
      getClassTeachersSchedule: build.query({
        query: (data) => ({
          url: `/mgmt/campus-classes/class-calendar/teachers/schedules`,
          method: 'POST',
          data,
        }),
        providesTags: ['teachers'],
      }),
    }),
  });

export const {
  useGetClassTeachersQuery,
  useGetClassTeachersScheduleQuery,
}: any = classCalendarAPI;
